import { LitElement, TemplateResult, html } from 'lit';
import { property, customElement, queryAssignedElements } from 'lit/decorators.js';

import encapsulatedStyles from './styles/outline-basic-card.encapsulated.pcss?inline';
import globalStyles from './styles/outline-basic-card.global.pcss?inline';
import { AdoptedStyleSheets } from '../../../controllers/adopted-stylesheets';

const componentName = 'outline-basic-card';

/**
 * The OutlineBasicCard component
 * @element outline-basic-card
 *
 * @extends LitElement
 *
 * @slot description - The card's main content.
 * @slot icon - An optional icon for the card.
 * @slot header - An optional header for the card.
 * @slot link - A slot to contain an anchor link, to have a clickable card.
 *
 */
@customElement('outline-basic-card')
export class OutlineBasicCard extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  render(): TemplateResult {
    return html`
      <div class="card">
        <div class="card--content">
          <div class="card--icon">
            <slot name="icon"></slot>
          </div>
          <div class="card--header">
            <slot name="header"></slot>
          </div>
          <div class="card--description">
            <slot></slot>
          </div>
          <div class="card--link">
            <slot name="link"></slot>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineBasicCard;
  }
}
